import { Button, Form, message, Input, Col, Row, Select } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import customDomainApis from 'api/customDomainApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';
import { Link } from 'react-router-dom';

export default function ListCustomDomainsPage() {

  const [custom_domains, setCustomDomains] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({})
  const [searchForm] = Form.useForm();

  async function fetchCustomDomains(params={}) {
    setIsFetching(true);
    try {
      const res = await customDomainApis.listing(params);
      if (res.code === 200) {
        setCustomDomains(res.data ?? []);
        setPaginate({page: res.page, limit: res.limit, total: res.total})
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    fetchCustomDomains()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const args = Object.assign({}, params, searchForm.getFieldsValue())
    await fetchCustomDomains(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchCustomDomains(params)
  };

  const handleChangeIsSetupCompleted = async (value, id) => {
    try {
      const params = {
        is_setup_completed: value === 'true'
      }
      console.log(params)
      const res = await customDomainApis.setup_domain(id, params);
      if (res.code === 200) {
        message.success('Successful');
      }
    } catch (error) {
      message.info(error.message);
    }
  };

  const bottom = 'bottomRight';

  const columns = [
    {
      title: 'ID',
      width: '15rem',
      render: (record) => <span>{record.id}</span>
    },
    {
      title: 'tenant_id',
      width: '15rem',
      render: (record) => <span>{record.tenant_id}</span>
    },
    {
      title: 'Name',
      width: '15rem',
      render: (record) => <span>{record.name}</span>
    },
    {
      title: 'status',
      width: '15rem',
      render: (record) => <span>{record.status}</span>
    },
    {
      title: 'is_affiliate',
      width: '15rem',
      render: (record) => <span>{String(record.is_affiliate)}</span>
    },
    {
      title: 'kind',
      width: '15rem',
      render: (record) => <span>{String(record.kind)}</span>
    },
    {
      title: 'is_setup_completed',
      width: '15rem',
      render: (record) => <span>{String(record.is_setup_completed)}</span>
    },
    {
      title: 'created_at',
      width: '7rem',
      key: 'created_at',
      sorter: true,
      render: (record) => <span>{fullDateTimeFormat(record.created_at)}</span>
    },
    {
      title: 'updated_at',
      width: '7rem',
      render: (record) => <span>{fullDateTimeFormat(record.updated_at)}</span>
    },
    {
      title: 'Chức năng',
      width: '10rem',
      render: (record) => (
        <>
          <p>
            <Button type="primary">
              <Link to={`/categories/${record.id}`}>Cập nhật</Link>
            </Button>
          </p>
        </>
      )
    }
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả custom_domains"
        pageHeaderExtras={
          <>
            <Button type="primary">
              Thêm
            </Button>
          </>
        }
      />
      <br />
      <ContentRow capped>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinishSearchForm}
          style={{marginBottom: "40px"}}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='name'
                label='name'
              >
                <Input placeholder="Tìm theo name" />
              </Form.Item>
            </Col>
            <Col
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  onFinishSearchForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          // @ts-ignore
          columns={columns}
          dataSource={custom_domains}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
    </>
  );
}


